<template>

	<div class="container-fluid e-menu">
		<ul class="menu-list">
			<li v-for="item in items" :class="{'item': true, '-active': item.active}" @click="jumpTo(item.name)">
				{{ item.title }}
			</li>
		</ul>

		<erco-dropdown v-if="languageSelectorIsVisible"
		               size="sm"
		               class="lang-selector"
		               :right="true"
		               :currentItemIndex="selectedLangIndex"
		               :items="langs"
		               @change="handleLanguageChange">
		</erco-dropdown>
	</div>

</template>

<script>
	import Const from '@/constants';

	import ErcoDropdown from '@/components/molecules/ErcoDropdown';

	export default {
		name: 'ErcoMenuAtom',

		props: {
			items: {
				type: Array,
				required: true,
			},

			jumpTo: {
				type: Function,
				required: true,
			},
			lang: {
				type: String,
				default: 'de',
			},
		},

		data() {
			return {
				langs: (() => Const.langs.slice().map(lang => ({
					value: lang.key,
					text: lang.textLong,
				})))(),
			};
		},

		computed: {
			languageSelectorIsVisible() {
				/* Nur sichtbar, wenn der Layout-Reiter aktiv ist */
				const activeItem = this.items.find(item =>
					item.active && ['assets', 'layout'].includes(item.name));
				return !!activeItem;
			},

			selectedLangIndex() {
				const index = this.langs.findIndex(lang => lang.value === this.lang);
				return Math.max(0, index);
			},
		},

		methods: {
			handleLanguageChange(item) {
				const lang = item.currentValue;
				this.$store.dispatch('setObjectLanguage', lang);
			},
		},

		components: {
			ErcoDropdown,
		},
	};
</script>


<style lang="scss">
	.e-menu {
		background-color: #373A3C;
		color: white;
		display: flex;

		.menu-list {
			margin: 0 0 0 3rem;
			padding: 1rem 0;
			display: inline-block;
			flex: 1;

			.item {
				&.-active {
					color: rgba(255, 255, 255, 1);
				}

				color: rgba(255, 255, 255, 0.5);
				cursor: pointer;
				display: inline;
				margin-right: 1.5rem;
			}
		}

		.lang-selector {
			flex: 0;
			margin: 0.8rem 0;
		}
	}
</style>



// WEBPACK FOOTER //
// ErcoMenu.vue?3de8a481